<script>
import dataInfo from './data'
import UseDialog from '@/components/UseDialog.vue'
import qiyuMixin from '@/mixins/form/qiyu'
export default {
  name: 'ComputeCard',
  mixins: [qiyuMixin],
  components: { UseDialog },
  props: {},
  data() {
    return {
      showResult: false, // 结果卡片
      timer: null,
      score: 0, // 计算得分
      level: 0, // 得分==>等级
      result: {},
      priceInfo: [
        {
          key: '5',
          count: '100份签署流量包',
          price: '650',
          each: '低至6.5元/份',
          total1: '650/年',
        },
      ],
      versionInfo: '',
      // 收益
      gains: {
        efficiency: '',
        cover: '',
      },
      suffix: '',
      needLocal: false, // 是否需要本地部署
      firstList: JSON.parse(JSON.stringify(dataInfo.firstList)),
      levelList: JSON.parse(JSON.stringify(dataInfo.levelList)),
      controlList: JSON.parse(JSON.stringify(dataInfo.controlList)),
      priceList: JSON.parse(JSON.stringify(dataInfo.priceList)),
      baseTag: false,
    }
  },
  computed: {
    getLink() {
      return 'https://www.esign.cn/site/quotation?tag=1'
    },
  },
  mounted() {},
  methods: {
    // goPrice() {
    //     this.$store.commit('home/setShowCompute', false);
    //     // this.$router.push({ path: '/site/quotation', query: { tag: '1' } });
    // },
    getGain(name) {
      // 定义一个映射对象
      const versionMapping = {
        基础版: { efficiency: '500%', cover: '70%' },
        专业版: { efficiency: '600%', cover: '80%' },
        高级版: { efficiency: '700%', cover: '90%' },
      }
      const gains = versionMapping[name]
      if (gains) {
        this.gains.efficiency = gains.efficiency
        this.gains.cover = gains.cover
      }
    },
    onChange(isNumber) {
      if (!isNumber) return
      // 根据前面下拉框选择 5-100 6-500 7-1000 8-2000 50-大于2000  拿到key根据key从priceList取值
      const { key } = this.firstList[0]
      this.priceInfo = this.priceList.filter(item => item.key === key)
      // console.log('------price-----', this.priceInfo);
    },
    close() {
      this.showResult = false
      this.$store.commit('user/setShowCompute', false)
      this.$store.commit('user/setShowTel', true)
      this.$emit('close', 'active')
    },
    compute() {
      const score = this.firstList.reduce((sum, item) => sum + Number(item.key), 0)
      // (0,10]基础版 （10,50]专业版|基础版 （50，99] 高级版|专业版  [100，+）高级版
      const level = score <= 10 ? 0 : score <= 50 ? 1 : score <= 99 ? 2 : 3

      this.score = score
      this.level = level
      this.needLocal = this.firstList[2].key === '50' // 是否需要本地部署 根据分值
      // 获取到level从levelList获取展示数据
      const data = this.levelList.filter(item => item.id === this.level)
      this.result = data[0]
      const { name } = data[0].versionList[0]
      this.versionInfo = `${name}年费` // 默认都是第一个

      if (data[0] && data[0].versionList[0]) {
        const version = data[0].versionList[0].name
        this.getGain(version)
      }
      this.baseTag = data[0].versionList.length === 1 && this.priceInfo[0].count === '100份签署流量包'
      this.showResult = true
    },
    getCard(id, name) {
      this.versionInfo = name
      // 定义一个映射对象
      this.getGain(name)
      this.$refs.versionCard.forEach((item, index) => {
        item.classList.remove('active')
        if (index === id) item.classList.add('active')
      })
      if (name === '基础版') {
        this.versionInfo = '980/年'
      } else {
        this.versionInfo = `${name}年费`
      }
    },
    showKefu() {
      // 百度爱番番客服
      this.handleNewBaiduService()
    },
    openPerfectInfoDialog() {
      this.$refs.dialog.showDialog()
    },
  },
}
</script>

<template>
  <div class="compute-main">
    <div v-if="!showResult" class="first-card">
      <!--关闭-->
      <img
        src="https://trial-cdn.esign.cn/upload/69129e56-65fe-54c4-b5f8-96f1cc4bc3ca!!7-29.png"
        alt=""
        class="first-close"
        @click="close"
      />
      <div class="first-card-main">
        <div class="title">
          <!--=={{ score }}=={{ level }}=={{ needLocal }}-->
          <img class="compute-img" src="https://trial-cdn.esign.cn/upload/edd1ebe4-c90f-5256-9014-7708c0128b25!!7-29.png" alt="" />
          价格计算器
        </div>
        <div v-for="item in firstList" :key="item.name" class="choose-item">
          <div class="left">
            <div class="name">{{ item.name }}</div>
            <div v-if="item.needTip">
              <el-tooltip class="item" effect="dark" :content="item.tip" placement="top">
                <img src="https://trial-cdn.esign.cn/upload/8ec9a7e1-93cc-54e6-ae6c-e975f23ac2ca!!7-29.png" alt="" />
              </el-tooltip>
            </div>
          </div>
          <div class="right">
            <el-select
              v-if="item.isSelect"
              v-model="item.key"
              placeholder="请选择"
              @change="onChange(item.isNumber)"
              :popper-append-to-body="false"
            >
              <el-option v-for="h in item.itemList" :key="h.value" :label="h.label" :value="h.value"> </el-option>
            </el-select>
            <el-radio-group v-else v-model="item.key">
              <el-radio-button v-for="radio in item.itemList" :key="radio.value" class="radio-item" :label="radio.value">{{
                radio.label
              }}</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="start-btn" @click="compute">开始计算</div>
      </div>
    </div>
    <div v-else class="result-card">
      <!--关闭-->
      <img
        src="https://trial-cdn.esign.cn/upload/69129e56-65fe-54c4-b5f8-96f1cc4bc3ca!!7-29.png"
        alt=""
        class="result-close"
        @click="close"
      />
      <!--重新计算-->
      <div class="re-start" @click="showResult = false">重新计算</div>
      <div class="result-card-left">
        <div class="result-title">
          <img src="https://trial-cdn.esign.cn/upload/457b3228-25fa-5bcc-bcca-b1754bbd928d!!7-30.png" alt="" />
          <div class="title">计算结果</div>
          <div class="sub-title">您的企业适合</div>
        </div>
        <div class="result-card-left-line1">
          <div class="title">
            <img src="https://trial-cdn.esign.cn/upload/9a7b5a15-4b41-5cd0-a952-35c3fad95146!!8-5.png" alt="" />
            份数套餐
          </div>
          <div class="line1-main">
            <div class="count">{{ baseTag ? '附赠100份签署流量 ' : priceInfo[0].count }}</div>
            <div v-show="!baseTag" class="price" :class="[priceInfo[0].key === '50' ? 'text' : '']">
              <img
                v-show="priceInfo[0].key !== '50'"
                class="price-icon"
                src="https://trial-cdn.esign.cn/upload/bc0c002f-5adb-507f-95ce-2dab7e5e97cd!!7-30.png"
                alt=""
              />
              {{ priceInfo[0].price }}
            </div>
            <div v-show="!baseTag" class="each">{{ priceInfo[0].each }}</div>
            <a class="more" :href="getLink" target="_blank">查看更多阶梯价格</a>
          </div>
        </div>
        <div class="result-card-left-line2">
          <div class="title">
            <img src="https://trial-cdn.esign.cn/upload/0db7b846-16fb-5f06-8b34-dc4f3f02e78a!!8-5.png" width="15px" height="14px" alt />
            版本推荐
          </div>
          <div
            v-for="(item, index) in result.versionList"
            :key="item.id"
            ref="versionCard"
            class="version-item"
            :class="[index === 0 ? 'active' : '']"
            @click="getCard(item.id, item.name)"
          >
            <div class="head">
              <div v-if="index === 0" class="recommend">
                <img src="https://trial-cdn.esign.cn/upload/73dc7ecf-032d-5003-aaa5-58dca822dfac!!7-30.png" alt="" />
              </div>
              <div v-if="index === 1" class="can-use">
                可用
              </div>
              <div class="type">
                {{ item.name }}
              </div>
              <div class="for">{{ item.for }}</div>
            </div>
            <div class="tag-con">
              <div v-for="tag in item.tagList" :key="tag" class="tag-item">
                <img src="https://trial-cdn.esign.cn/upload/4538205c-3dde-591a-a8c7-5afff4e81980!!7-30.png" alt="" />
                {{ tag }}
              </div>
            </div>
          </div>
        </div>
        <div class="bottom">
          <div class="bottom-left">
            <div class="all">总计：</div>
            <div class="count text" v-show="!baseTag">{{ priceInfo[0].total1 || '' }}</div>
            <div class="text plus" v-show="!baseTag">+</div>
            <div class="price text">
              {{ baseTag ? '980/年' : versionInfo }}
            </div>
            <div v-if="needLocal" class="text plus">+</div>
            <div v-if="needLocal" class="yun text">专属云部署</div>

            <div class="tel-consult">
              <div class="top" @click="showKefu">优惠咨询</div>
              <div class="tel">0571-85785223</div>
            </div>
            <div class="qr">
              <img src="https://trial-cdn.esign.cn/upload/7c26c557-2a60-5c2d-8aac-60fa0df2b4d4!!5-29.png" alt="" />
            </div>
          </div>
        </div>
      </div>

      <div class="result-card-right">
        <p class="result-card-right-title">带来的收益</p>
        <div class="save-con">
          <div class="save-title">节省</div>
          <div class="save-item">
            <div class="save-name">文印成本</div>
            <div class="tip">
              <el-tooltip class="item" effect="dark" content="按一份合同10元计算（一份合同10页，每页耗材0.5元 一式两份）" placement="top">
                <img src="https://trial-cdn.esign.cn/upload/b478d7d8-0cc0-5222-b128-ae262efa137f!!7-30.png" alt="" />
              </el-tooltip>
            </div>
            <div class="save-result">{{ priceInfo[0].printCost || '1000元/年' }}</div>
          </div>
          <div class="save-item">
            <div class="save-name">物流成本</div>
            <div class="tip">
              <el-tooltip class="item" effect="dark" content="按一份合同12元计算（仅计算发起方的物流成本）" placement="top">
                <img width="16px" src="https://trial-cdn.esign.cn/upload/b478d7d8-0cc0-5222-b128-ae262efa137f!!7-30.png" alt="" />
              </el-tooltip>
            </div>
            <div class="save-result">
              {{ priceInfo[0].LogisticsCosts || '1200元/年' }}
            </div>
          </div>
        </div>
        <div class="control-con">
          <div class="control-title">控制</div>
          <div class="control-tag">
            <div v-for="item in controlList" :key="item" class="control-tag-item">
              {{ item }}
            </div>
          </div>
        </div>
        <div class="efficiency">
          效率提升&nbsp;&nbsp;&nbsp;<span class="up">{{ gains.efficiency }}</span>
        </div>
        <div class="cost">
          成本降低&nbsp;&nbsp;&nbsp;<span class="up">{{ gains.cover }}</span>
        </div>
        <div class="free-btn" @click="openPerfectInfoDialog">免费试用</div>
      </div>
    </div>

    <!-- 免费试用申请弹框 -->
    <UseDialog ref="dialog" :wlCode="true" />
  </div>
</template>

<style scoped lang="less">
::v-deep .el-select-dropdown {
  top: 100% !important;
  left: 0 !important;
  position: absolute !important;
}
::v-deep .el-select-dropdown__item.selected {
  color: #e3202a !important;
}

::v-deep .el-radio-button__inner {
  padding: 13px 39px !important;
  background: linear-gradient(180deg, #f5f7fb 0%, #ffffff 100%) !important;
  box-shadow: 0 2px 10px 0 rgba(190, 200, 211, 0.6) !important;
  border-radius: 6px !important;
  border: 1px solid #ffffff !important;
  &:hover {
    color: #e3202a !important;
  }
}

::v-deep .el-radio-button--small .el-radio-button__inner {
  font-size: 14px !important;
}

::v-deep .is-active .el-radio-button__inner {
  background: #e3202a !important;
  box-shadow: 0 2px 10px 0 rgba(215, 225, 234, 0.6) !important;
  color: #ffffff !important;
}

::v-deep .el-radio-button:first-child .el-radio-button__inner {
  box-shadow: 0 2px 10px 0 rgba(190, 200, 211, 0.6) !important;
}

::v-deep .el-radio-button:last-child .el-radio-button__inner {
  margin-left: 10px !important;
}

::v-deep .el-select .el-input input {
  background: linear-gradient(180deg, #f5f7fb 0%, #ffffff 100%) !important;
  box-shadow: 0 2px 10px 0 rgba(190, 200, 211, 0.6) !important;
  border-radius: 6px !important;
  border: 1px solid #ffffff !important;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500 !important;
  font-size: 16px !important;
  color: rgba(0, 0, 0, 0.85) !important;
  line-height: 22px !important;
  text-align: left !important;
  font-style: normal !important;
}

::v-deep .el-input--small .el-input__inner {
  height: 40px !important;
}

/* 选择器需要根据实际情况进行调整，以下是示例 */
::v-deep .el-select .el-input__suffix .el-input__suffix-inner .el-input__icon::before {
  content: '' !important;
  background: url('https://trial-cdn.esign.cn/upload/6c85c6e3-306d-59c2-90e8-cfdff1519c55!!7-29.png') no-repeat !important;
  background-size: contain !important;
  display: inline-block !important;
  width: 15px !important;
  height: 12px !important;
}

/* 添加自定义图标 */
//.el-select .el-input__suffix .el-input__suffix-inner {
//  background: url('path/to/your/custom/icon.png') center no-repeat;
//  background-size: contain;
//}

.compute-main {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.65);
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  .first-card {
    width: 583px;
    height: 452px;
    background: rgba(255, 255, 255, 0.2);
    box-shadow: 0 5px 21px 0 rgba(42, 42, 42, 0.5);
    border-radius: 36px;
    backdrop-filter: blur(10px);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .first-close {
      width: 30px;
      position: absolute;
      top: 0;
      left: 102%;
      cursor: pointer;
    }
    .first-card-main {
      width: 560px;
      height: 431px;
      background: #ffffff;
      border-radius: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      box-sizing: border-box;
      padding: 0 52px;
      .choose-item {
        user-select: none;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        .left {
          width: calc(100% - 200px);
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          padding-right: 50px;
          box-sizing: border-box;
          img {
            width: 16px;
            margin-left: 8px;
          }
          .name {
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: rgba(0, 0, 0, 0.85);
            line-height: 25px;
            text-align: left;
            font-style: normal;
          }
        }
        .right {
          width: 200px;
          height: 40px;
        }
      }
      .choose-item:nth-of-type(6) {
        margin-bottom: 30px;
      }
      .title {
        user-select: none;
        width: 477px;
        height: 52px;
        background: linear-gradient(180deg, #1a1a1a 0%, #b90000 100%);
        border-radius: 8px;
        margin-bottom: 25px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 22px;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-style: normal;
        .compute-img {
          width: 23px;
          height: 22px;
          margin-right: 10px;
          margin-top: 3px;
        }
      }
      .start-btn {
        width: 256px;
        height: 46px;
        background: #e63740;
        border-radius: 23px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 20px;
        color: #ffffff;
        line-height: 46px;
        text-align: center;
        font-style: normal;
        cursor: pointer;
      }
    }
  }
  .result-card {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    user-select: none;
    .re-start {
      position: absolute;
      bottom: -60px;
      left: 50%;
      transform: translateX(-50%);
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 20px;
      color: #ffffff;
      line-height: 28px;
      text-align: center;
      font-style: normal;
      text-decoration-line: underline;
      cursor: pointer;
    }
    .result-close {
      width: 30px;
      position: absolute;
      top: -13px;
      left: 103%;
      cursor: pointer;
    }
    .result-card-left {
      width: 690px;
      height: 487px;
      background: #ffffff;
      border-radius: 30px;
      padding: 30px;
      position: relative;
      margin-right: 10px;
      .result-title {
        display: flex;
        align-items: flex-end;
        justify-content: flex-start;
        margin-bottom: 30px;
        user-select: none;
        img {
          width: 23px;
          height: 23px;
          margin-right: 7px;
        }
        .title,
        .sub-title {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.85);
          text-align: left;
        }
        .title {
          font-size: 26px;
          margin-right: 10px;
        }
        .sub-title {
          font-size: 14px;
        }
      }
      .result-card-left-line1 {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 40px;
        .title {
          user-select: none;
          font-size: 16px;
          font-weight: 600;
          margin-right: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 15px;
            margin-right: 4px;
          }
        }
        .line1-main {
          user-select: none;
          width: 528px;
          height: 48px;
          background: linear-gradient(180deg, #f5f7fb 0%, #ffffff 100%);
          box-shadow: 0 2px 10px 0 rgba(190, 200, 211, 0.6);
          border-radius: 6px;
          border: 1px solid #ffffff;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          padding: 0 10px;
          box-sizing: border-box;
          .count,
          .price,
          .each,
          .more {
            font-family: PingFangSC, PingFang SC;
          }
          .count {
            user-select: none;
            width: 166px;
            height: 37px;
            background: #e3202a;
            border-radius: 6px;
            font-weight: 600;
            font-size: 16px;
            color: #ffffff;
            line-height: 37px;
            text-align: center;
            margin-right: 28px;
          }
          .price {
            user-select: none;
            font-weight: 600;
            font-size: 28px;
            color: #e3202a;
            line-height: 20px;
            text-align: left;
            margin-right: 9px;
            position: relative;
            .price-icon {
              width: 14px;
              position: absolute;
              left: -10px;
              bottom: 0;
            }
          }
          .price.text {
            font-size: 20px;
          }
          .each {
            user-select: none;
            font-weight: 400;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.65);
            margin-right: 50px;
            margin-top: 10px;
          }

          .more {
            font-weight: 400;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.45);
            text-decoration-line: underline;
            margin-top: 10px;
            position: absolute;
            right: 58px;
          }
        }
      }
      .result-card-left-line2 {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        .title {
          user-select: none;
          margin-right: 18px;
          font-size: 16px;
          font-weight: 600;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 15px;
            margin-right: 4px;
          }
        }
        .version-item {
          width: 246px;
          height: 160px;
          background: #ffffff;
          box-shadow: 0 2px 16px 0 rgba(205, 218, 230, 0.8);
          border-radius: 8px;
          box-sizing: border-box;
          user-select: none;
          .head {
            width: 100%;
            height: 51px;
            padding-left: 14px;
            box-sizing: border-box;
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            flex-direction: column;
            background: linear-gradient(90deg, #ff5757 0%, #ffa4a4 100%);
            border-radius: 8px 8px 0 0;
            position: relative;
            .recommend {
              position: absolute;
              top: 0;
              right: 0;
              width: 37px;
              img {
                width: 100%;
              }
            }
            .free-use,
            .can-use {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 11px;
              color: rgba(0, 0, 0, 0.65);
              line-height: 16px;
              text-align: left;
              font-style: normal;
              position: absolute;
              right: 12px;
              top: 12px;
            }
            .can-use {
              color: green;
            }

            .type {
              width: 100%;
              text-align: left;
              font-weight: 600;
              margin-top: 8px;
              margin-bottom: 3px;
              font-family: PingFangSC, PingFang SC;
              font-size: 14px;
              color: rgba(0, 0, 0, 0.85);
              font-style: normal;
            }
            .for {
              width: 100%;
              text-align: left;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 12px;
              color: rgba(0, 0, 0, 0.65);
              line-height: 17px;
              font-style: normal;
            }
          }
          .tag-con {
            padding-left: 20px;
            box-sizing: border-box;
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            flex-direction: column;
            height: calc(100% - 60px);
            padding-top: 14px;
            .tag-item {
              font-size: 12px;
              margin-bottom: 10px;
              display: flex;
              align-items: center;
              justify-content: flex-start;
              img {
                width: 13px;
                margin-right: 10px;
              }
            }
          }
        }
        .version-item:nth-of-type(2) {
          margin-right: 19px;
          .head {
            box-shadow: 0 2px 16px 0 rgba(255, 201, 186, 0.8);
            .star-con {
              bottom: 3px;
              right: 7px;
              width: 83px;
            }
          }
        }
        .version-item:nth-of-type(3) {
          .head {
            background: linear-gradient(90deg, #fff8f1 0%, #ffeddd 100%);
            .star-con {
              width: 16px;
              bottom: 3px;
              right: 23px;
            }
          }
        }
        .version-item.active {
          width: 262px;
          height: 176px;
          background: #ffffff;
          box-shadow: 0 2px 16px 0 rgba(255, 201, 186, 0.8);
          border-radius: 8px;
          .head {
            height: 57px;
            .type {
              //color: #ffffff;
              margin-bottom: 6px;
            }
            .star-con {
              bottom: 6px;
              right: 14px;
            }
          }
        }
      }
      .bottom {
        position: absolute;
        bottom: 16px;
        left: 50%;
        transform: translateX(-50%);
        width: 95%;
        height: 80px;
        background: url('https://trial-cdn.esign.cn/upload/e8b7a6e5-0f85-5582-8851-10345f62f9db!!8-6.png') no-repeat center center;
        background-size: cover;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 12px;
        box-sizing: border-box;
        padding: 0 24px;
        .bottom-left,
        .bottom-right {
          display: flex;
          box-sizing: border-box;
        }
        .bottom-left {
          justify-content: center;
          align-items: flex-start;
          height: 80px;
          padding-top: 16px;
          .all,
          .text {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 17px;
            color: #ffffff;
            line-height: 25px;
            text-align: left;
            font-style: normal;
          }
          .plus {
            margin: 0 6px;
          }
          .count,
          .price,
          .yun {
            position: relative;
          }
          .count::after {
            content: '合同份数费用';
            position: absolute;
            top: 123%;
            left: 50%;
            transform: translateX(-50%);
            width: 100px;
            text-align: center;

            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 12px;
            color: #ffbb80;
            line-height: 17px;
            font-style: normal;
          }
          .price::after {
            content: '版本费用';
            position: absolute;
            top: 123%;
            left: 50%;
            transform: translateX(-50%);
            width: 100px;
            text-align: center;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 12px;
            color: #ffbb80;
            line-height: 17px;
            font-style: normal;
          }
          .yun::after {
            content: '部署费用';
            position: absolute;
            top: 123%;
            left: 50%;
            transform: translateX(-50%);

            width: 100px;
            text-align: center;

            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 12px;
            color: #ffbb80;
            line-height: 17px;
            font-style: normal;
          }

          .tel-consult {
            margin-left: 22px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            .tel {
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 12px;
              color: #ffffff;
              line-height: 17px;
              text-align: center;
              font-style: normal;
            }
            .top {
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              font-size: 16px;
              color: #ffffff;

              font-style: normal;
              margin-bottom: 7px;

              line-height: 34px;
              text-align: center;

              width: 131px;
              height: 34px;
              background: #e63740;
              border-radius: 23px;
              cursor: pointer;
            }
          }
          .qr {
            margin-left: 22px;
            margin-top: -10px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 70px;
            height: 70px;
            background: #ffffff;
            border-radius: 8px;
            padding: 2px;
            box-sizing: border-box;
            img {
              width: 100%;
              //border-radius: inherit;
            }
          }
        }
        //.bottom-right {
        //    justify-content: flex-end;
        //    align-items: center;
        //    .tel-consult {
        //        display: flex;
        //        align-items: center;
        //        justify-content: center;
        //        flex-direction: column;
        //        .tel {
        //            font-family: PingFangSC, PingFang SC;
        //            font-weight: 500;
        //            font-size: 12px;
        //            color: #ffffff;
        //            line-height: 17px;
        //            text-align: center;
        //            font-style: normal;
        //        }
        //        .top {
        //            font-family: PingFangSC, PingFang SC;
        //            font-weight: 600;
        //            font-size: 16px;
        //            color: #ffffff;
        //
        //            font-style: normal;
        //            margin-bottom: 7px;
        //
        //            line-height: 34px;
        //            text-align: center;
        //
        //            width: 131px;
        //            height: 34px;
        //            background: #e63740;
        //            border-radius: 23px;
        //            cursor: pointer;
        //        }
        //    }
        //    .qr {
        //        margin-left: 21px;
        //        display: flex;
        //        align-items: center;
        //        justify-content: center;
        //        width: 70px;
        //        height: 70px;
        //        background: #ffffff;
        //        border-radius: 8px;
        //        padding: 2px;
        //        box-sizing: border-box;
        //        img {
        //            width: 100%;
        //            //border-radius: inherit;
        //        }
        //    }
        //}
      }
    }
    .result-card-right {
      width: 309px;
      height: 487px;
      background: url('https://trial-cdn.esign.cn/upload/eb93d6ce-7649-59fd-8532-8dbf069242d7!!7-29.png') no-repeat center center;
      background-size: cover;
      padding: 20px;
      border-radius: 30px;
      position: relative;
      .result-card-right-title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 26px;
        color: #ffffff;
        text-align: center;
        margin-bottom: 18px;
      }
      .save-con {
        .save-title {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 20px;
          color: #ffffff;
          text-align: center;
          position: relative;
          margin-bottom: 15px;
        }
        .save-title::before {
          position: absolute;
          content: '';
          width: 86px;
          height: 1px;
          background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }
        .save-title::after {
          position: absolute;
          content: '';
          width: 86px;
          height: 1px;
          background: linear-gradient(90deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
          right: 0;
          top: 50%;
          transform: translateY(-50%);
        }
        .save-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: relative;
          margin-bottom: 18px;
          .save-name,
          .save-result {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 16px;
            color: #ffffff;
            line-height: 22px;
            text-align: left;
          }
          .tip {
            //filter: invert(1);
            position: absolute;
            left: 76px;
            bottom: 2px;
            width: 16px;
          }
        }
      }
      .control-con {
        width: 100%;
        margin-top: 20px;
        .control-title {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 20px;
          color: #ffffff;
          text-align: center;
          position: relative;
          margin-bottom: 11px;
        }
        .control-title::before {
          position: absolute;
          content: '';
          width: 86px;
          height: 1px;
          background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }
        .control-title::after {
          position: absolute;
          content: '';
          width: 86px;
          height: 1px;
          background: linear-gradient(90deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
          right: 0;
          top: 50%;
          transform: translateY(-50%);
        }

        .control-tag {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          margin-top: 18px;
          padding: 0 10px;
          .control-tag-item {
            width: 114px;
            height: 36px;
            border-radius: 4px;
            border: 1px solid rgba(255, 255, 255, 0.7);
            margin-bottom: 12px;

            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: rgba(255, 255, 255, 0.8);
            line-height: 36px;
            text-align: center;
          }
        }
      }

      .efficiency,
      .cost {
        font-size: 18px;
        text-align: center;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 25px;
        font-style: normal;
        .up {
          font-size: 24px;
          font-weight: 600;
        }
      }
      .efficiency {
        margin-top: 6px;
      }
      .cost {
        margin-top: 14px;
        margin-bottom: 15px;
      }
      .free-btn {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 18px;
        color: #ffffff;
        text-align: center;
        font-style: normal;
        line-height: 46px;
        margin: 0 auto;
        cursor: pointer;
        width: 193px;
        height: 46px;
        background: #e63740;
        border-radius: 23px;
      }
    }
  }
  .result-card::before {
    content: '';
    width: 1042px;
    height: 515px;
    background: rgba(255, 255, 255, 0.2);
    box-shadow: 0 5px 21px 0 rgba(42, 42, 42, 0.5);
    border-radius: 36px;
    backdrop-filter: blur(10px);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
